import { makeKeyValueRepository } from '../../../../data/repositories/key-value/key-value-repository-factory';
import { makeLogService } from '../../../../data/services/common/log/log/log-service-factory';
import { makeEntityService } from '../../../../data/services/http/entity/entity-service-factory';
import { LoadEntityFromCentralUseCase } from './load-entity-from-central-use-case';

export function makeLoadEntityFromCentralUseCase() {
  return new LoadEntityFromCentralUseCase(
    makeLogService(),
    makeEntityService(),
    makeKeyValueRepository(),
  );
}
